// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".8023c55cd36c75b22af06dcd4540004fd59d6a44.chunk.js";
};